import React from 'react';
import { Brain, Box, Shuffle, Gamepad2, Paperclip, Activity } from 'lucide-react';

const upgrades = [
  {
    icon: Brain,
    color: 'bg-purple-600',
    title: '55 AI Models, One Picker',
    text: 'Every model on the Universal roster — GPT-6 Astra, Claude Fable 5.1, Gemini 3.8 Flash and 50+ more. Swap brains mid-project.',
    badge: 'NEW',
  },
  {
    icon: Box,
    color: 'bg-pink-600',
    title: 'Cinematic 3D Engine',
    text: 'True WebGL 3D with golden-hour lighting, soft shadows, fog and tone-mapped color. Ask for a 3D game and get a cinematic one.',
    badge: 'UPGRADED',
  },
  {
    icon: Shuffle,
    color: 'bg-blue-600',
    title: 'Remix Any Game',
    text: 'See a game you love? Hit "Remix with AI" on its play page and fork it into your own editable session — free.',
  },
  {
    icon: Gamepad2,
    color: 'bg-green-600',
    title: 'Play Anywhere',
    text: 'Every game ships with a touch virtual gamepad, so your players can jump in from any phone or tablet.',
  },
  {
    icon: Paperclip,
    color: 'bg-amber-600',
    title: 'Feed It Your Ideas',
    text: 'Attach up to 50MB of PDFs, design docs, videos or sketches. The AI reads them and builds them into your game.',
  },
  {
    icon: Activity,
    color: 'bg-cyan-600',
    title: 'Live Build Progress',
    text: 'Watch every build stage in real time — no black boxes. Cancel anytime and you are never charged for it.',
  },
];

const WhatsNewSection = () => {
  return (
    <section id="whats-new" className="py-24 bg-gradient-to-b from-black via-purple-950/10 to-black" data-testid="whats-new-section">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-16">
          <h2 className="text-4xl md:text-5xl font-bold text-white mb-4">
            Fresh Off the
            <span className="bg-gradient-to-r from-purple-400 to-pink-400 bg-clip-text text-transparent"> Update Train</span>
          </h2>
          <p className="text-gray-400 text-lg max-w-2xl mx-auto">
            GameOS keeps shipping. Here's what's new in the engine room.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
          {upgrades.map((u, i) => (
            <div
              key={i}
              data-testid={`whats-new-card-${i}`}
              className="bg-gradient-to-br from-gray-900 to-gray-800 rounded-2xl p-6 border border-white/10 hover:border-purple-500/50 transition-all duration-300"
            >
              <div className="flex items-center justify-between mb-4">
                <div className={`w-10 h-10 ${u.color} rounded-lg flex items-center justify-center`}>
                  <u.icon size={20} className="text-white" />
                </div>
                {u.badge && (
                  <span className="text-xs font-bold px-2 py-1 rounded-full bg-gradient-to-r from-purple-600 to-pink-600 text-white">
                    {u.badge}
                  </span>
                )}
              </div>
              <h3 className="text-xl font-bold text-white mb-2">{u.title}</h3>
              <p className="text-gray-400">{u.text}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default WhatsNewSection;
